import AdministrationAttributes from './AdministrationAttributes'

export default AdministrationAttributes
